module.exports = __webpack_public_path__ + "images/workstation.53d90271be8af01f68b5afe23e365cfe.jpg";